import React from 'react';
import Button from '@mui/material/Button';
import TuneIcon from '@mui/icons-material/Tune';
import ClearIcon from '@mui/icons-material/Clear';
import { useTranslation } from 'react-i18next';

const FilterActions = ({ onFilter, onClear, filterLabel, clearLabel }) => {
  const [t] = useTranslation('common');

  return (
    <div className="filter-actions">
      <Button
        className="filter-actions__btn filter-actions__btn--primary"
        variant="contained"
        disableElevation
        onClick={onFilter}
        startIcon={<TuneIcon />}
      >
        {filterLabel || t('compareperiods.filters')}
      </Button>
      <Button
        className="filter-actions__btn filter-actions__btn--secondary"
        variant="outlined"
        disableElevation
        onClick={onClear}
        startIcon={<ClearIcon />}
      >
        {clearLabel || t('compareperiods.clear')}
      </Button>
    </div>
  );
};

export default FilterActions;
